export type AccessStatus = 'PENDING' | 'APPROVED' | 'REJECTED';
export type NameVerdict = 'same' | 'likely_typo' | 'different' | 'unknown';

export interface PersonRef {
  id: string;
  firstName: string | null;
  lastName: string | null;
  email?: string | null;
}

export interface ExistingLead {
  id: string;
  name: string | null;
  assignedToId: string | null;
  assignedToName: string | null;
  canonicalStage: string | null;
}

export interface NameMatch {
  existingName: string | null;
  typedName: string | null;
  ratio: number;
  verdict: NameVerdict;
}

export interface AccessRequest {
  id: string;
  customerMobile: string;
  typedName: string | null;
  sourceLeadId: string | null;
  reason: string | null;
  note: string | null;
  status: AccessStatus;
  createdAt: string;
  decidedAt: string | null;
  decisionNote: string | null;
  requestedById: string;
  decidedById: string | null;
  requestedBy: PersonRef | null;
  /** 2026-10-03 — set when a coordinator raised it for her manager (requestedBy). */
  raisedById?: string | null;
  raisedBy?: PersonRef | null;
  decidedBy: PersonRef | null;
  existingLead: ExistingLead | null;
  nameMatch: NameMatch | null;
}

export const STAGE_LABELS: Record<string, string> = {
  cold: 'New',
  followup: 'Follow-up',
  quote: 'Quoted',
  neg: 'Negotiation',
  hot: 'Closing',
  won: 'Won',
  lost: 'Lost',
};

export const fullName = (p: PersonRef | null): string =>
  p ? `${p.firstName ?? ''} ${p.lastName ?? ''}`.trim() || (p.email ?? 'Unknown') : 'Unknown';

export const FILTERS: { key: string; label: string }[] = [
  { key: 'pending', label: 'Pending' },
  { key: 'approved', label: 'Approved' },
  { key: 'rejected', label: 'Rejected' },
  { key: '', label: 'All' },
];
